import { render, staticRenderFns } from "./Brokerage.vue?vue&type=template&id=7c7eb61c&scoped=true&"
import script from "./Brokerage.vue?vue&type=script&lang=js&"
export * from "./Brokerage.vue?vue&type=script&lang=js&"
import style0 from "./Brokerage.vue?vue&type=style&index=0&id=7c7eb61c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7eb61c",
  null
  
)

export default component.exports